import { get, post } from "../axios/http"

export const loginByUsername = params => post('/api/Login/Login', params, { headers:{'Content-Type': 'application/x-www-form-urlencoded'} })

export const getUserInfo = () => get('/api/User/Info');

export const checkByUsername = (username) => get(`/api/User/CheckByUsername?username=${username}`)

export const checkValidationCode = (tel, code) => post(`/api/checkValidationCode?phoneNumber=${tel}&validationCode=${code}`)

export const getValidationCode = tel => post(`/api/getValidationCode?phoneNumber=${tel}`)

export const register = (params) => post('/api/Register/Register', params)

export const retrieve = (params) => post('/api/User/RetrievePassword',params)